(function () {
  document.querySelectorAll('[data-coupon-copy]').forEach(function (button) {
    button.addEventListener('click', function () {
      var code = button.getAttribute('data-code');
      if (!code || !navigator.clipboard) return;

      navigator.clipboard.writeText(code).then(function () {
        button.classList.add('is-copied');

        var status = button.closest('.coupon-codes')
          ? button.closest('.coupon-codes').querySelector('[data-coupon-status]')
          : null;
        if (status) status.textContent = 'Código ' + code + ' copiado';

        window.clearTimeout(button._couponCopyTimeout);
        button._couponCopyTimeout = window.setTimeout(function () {
          button.classList.remove('is-copied');
        }, 1800);
      });
    });
  });
})();
